import { translate } from '@/ui/i18n';

//eslint-disable-next-line
export const isNumber = (number: any) => {
  return !isNaN(number) || translate('Form.must-be-a-number');
};

export const isFactor = (value: string) => {
  const regex = /^\d*\.?\d*(?:##)?\d*\.?\d*(?:##)?\d*\.?\d*$/;
  return regex.test(value) || translate('Form.must-be-numbers');
};

export const isAtLeastStartDate = (date: string, startDate: string) => {
  return (
    !startDate ||
    new Date(date).setHours(0, 0, 0, 0) >=
      new Date(startDate).setHours(0, 0, 0, 0) ||
    translate('Form.date-greater-than-start-date')
  );
};

export const isMaxBeforeEndDate = (date: string, endDate: string) => {
  return (
    !endDate ||
    new Date(date).setHours(0, 0, 0, 0) <=
      new Date(endDate).setHours(0, 0, 0, 0) ||
    translate('Form.date-lower-than-end-date')
  );
};

export const isEmail = (value: string) => {
  const regex = /\S+@\S+\.\S+/;
  const check = regex.test(value);
  return check || translate('Form.must-be-a-valid-email');
};

export const isWebsiteUrl = (value: string) => {
  const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
  const check = regex.test(value);
  return check || translate('Form.must-be-a-valid-url');
};
